var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgParkingLot03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2C3.79086 2 2 3.79086 2 6V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V6C22 3.79086 20.2091 2 18 2H6ZM11.7358 6.16016C10.4985 6.16016 9.32515 6.24016 8.21582 6.40016V18.0002H10.8878V14.0962C11.3572 14.1388 11.7838 14.1602 12.1678 14.1602C13.7038 14.1602 14.8665 13.8082 15.6558 13.1042C16.4558 12.3895 16.8558 11.3442 16.8558 9.96816C16.8558 7.42949 15.1492 6.16016 11.7358 6.16016ZM11.8958 12.1602C11.5652 12.1602 11.2292 12.1335 10.8878 12.0802V8.32016C11.2078 8.25616 11.5438 8.22416 11.8958 8.22416C13.5065 8.22416 14.3118 8.85882 14.3118 10.1282C14.3118 10.7682 14.0985 11.2695 13.6718 11.6322C13.2558 11.9842 12.6638 12.1602 11.8958 12.1602Z",
    fill: "#1C7A9E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgParkingLot03);
export default __webpack_public_path__ + "static/media/bg_parking-lot03.5da3fbc689b9f1c546e807cf225ef6b9.svg";
export { ForwardRef as ReactComponent };